/**
 * SwiperSlider
 * @description Web component used to create sliders, configurable with data-options attribute.
 */

(async () => {
  if (!customElements.get("swiper-slider")) {
    const {
      default: Swiper,
      Navigation,
      Pagination,
      Scrollbar,
      EffectFade,
      Autoplay,
    } = await import("swiper");

    Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);

    class SwiperSlider extends HTMLElement {
      constructor() {
        super();

        this.swiper = this;
        this.swiperOptions = {
          threshold: 10,
        };

        if (!this.swiper) {
          return;
        }

        // Check if we have extra options on the HTML
        if (this.swiper?.dataset?.options) {
          const options = parseJson(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

        // Add mouse event listeners for more reliable pause/resume functionality
        this.addMouseEvents();

        /**
         * Listen to extra events when in Shopify editor
         */
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggerd
          window.addEventListener("shopify:section:load", (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });

          // When on block select go to the slide in front-end
          window.addEventListener("shopify:block:select", (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener("shopify:block:deselect", (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });
        }
      }

      /**
       * Add mouse event listeners to handle pause/resume on hover
       */
      addMouseEvents() {
        // Only add mouse events if autoplay is enabled
        if (this.swiperOptions.autoplay) {
          this.addEventListener("mouseenter", () => {
            console.log(this.swiperInstance);
            console.log(this.swiperInstance.autoplay);
            console.log(this.swiperInstance.autoplay.pause);
            this.swiperInstance?.autoplay?.pause();
          });

          this.addEventListener("mouseleave", () => {
            this.swiperInstance?.autoplay?.start();
          });
        }
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect(event) {
        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) {
          return;
        }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex =
          parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if (this.swiperOptions.loop) {
          swipeToSlideIndex =
            parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiperInstance.slideTo(swipeToSlideIndex, 1000);
      }
    }

    window.SwiperSlider = SwiperSlider;

    customElements.define("swiper-slider", SwiperSlider);
  }
})();
